import zhCN from './zh_CN';
import enUS from './en_US';
var registeredLocale = {};
export function registerLocale(lang, localeObj) {
    // 重复命名的会直接覆盖原有的locale
    registeredLocale[lang] = localeObj;
}
export function getRegisteredLocale(lang) {
    return registeredLocale[lang] || zhCN;
}
registerLocale('zh_CN', zhCN);
registerLocale('en_US', enUS);
